import { useContext } from "react";
import { Table, TableBody, TableCell, TableHead, TableFooter, TableRow, Typography, Checkbox, TableContainer } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import { ClickableTableRow, DeleteIconButton } from 'components';
import { ticketsContext } from "../TicketsContext";
import { applicationContext, appUserContext } from "helpers/services";
import Moment from "react-moment";
import { UserType, TicketColumns } from "helpers/enums";
import SortableTableCell from "./TicketTableCell";
import { ExcelExport } from ".";


let Results = () => {
    let history = useHistory();
    let { customerServiceUsers, userGroups, ticketStatuses, ticketTypes, ticketPriorities } = useContext(applicationContext);
    let { tickets, setSelectedItems, selectedItems, recordCount, deleteTicket } = useContext(ticketsContext);
    let { currentUser } = useContext(appUserContext);
    
    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {currentUser?.canDoBulkEdit &&
                            <TableCell padding="checkbox">
                                <Checkbox
                                    checked={selectedItems.length > 0}
                                    indeterminate={selectedItems.length > 0 && selectedItems.length !== tickets.length}
                                    onChange={() => {
                                        if (selectedItems.length === tickets.length)
                                            setSelectedItems([])
                                        else
                                            setSelectedItems(tickets.map(x => x.id))
                                    }}
                                />
                            </TableCell>
                        }
                        <SortableTableCell column={TicketColumns.Ticket} />
                        <TableCell>Status</TableCell>
                        <TableCell>Type/Priority</TableCell>
                        {currentUser?.typology === UserType.VitecUser &&
                            <>
                                <SortableTableCell column={TicketColumns.Reporter} />
                                <SortableTableCell column={TicketColumns.Assignee} />
                                <SortableTableCell column={TicketColumns.CSAssignee} />
                            </>
                        }
                        <SortableTableCell column={TicketColumns.Title} />
                        {(currentUser?.canDeleteTickets || currentUser?.canCreateExcelTicketExport) &&
                            <>
                                {currentUser.typology === UserType.VitecUser &&
                                    <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
                                        <ExcelExport />
                                    </TableCell>
                                }
                            </>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tickets.map(ticket =>
                        <ClickableTableRow
                            hover
                            key={ticket.ticketNumber}
                            onClick={(e) => {
                                if (e.ctrlKey)
                                    window.open(`/ticket/${ticket.ticketNumber}/`);
                                else
                                    history.push(`/ticket/${ticket.ticketNumber}/`)
                            }}
                        >
                            {currentUser?.canDoBulkEdit &&
                                <TableCell
                                    padding="checkbox"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <Checkbox
                                        checked={selectedItems.find(value => value === ticket.id) !== undefined}
                                        onChange={(e, b) => {
                                            if (b)
                                                setSelectedItems([...selectedItems, ticket.id])
                                            else
                                                setSelectedItems(selectedItems.filter(x => x !== ticket.id))
                                        }}
                                    ></Checkbox>

                                </TableCell>
                            }

                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                                <b>{ticket.ticketNumber}</b>
                                <Typography variant="subtitle2">
                                    <Moment date={ticket.createdOn} format="L LT" />
                                </Typography>
                            </TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                                {/* i take the name for the result based on the type of user  */}
                                {ticketStatuses.find(x => x.id === ticket.ticketStatusId)?.
                                [(currentUser?.typology === UserType.VitecUser ? "name" : "customerStatus")]}
                            </TableCell>

                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                                {ticketTypes.find(x => x.id === ticket.ticketTypeId)?.name}
                                <Typography
                                    variant="subtitle2"
                                    style={{ color: ticketPriorities.getValueByKey(ticket.ticketPriorityId, 'id', 'color') }}
                                >
                                    {ticketPriorities.getValueByKey(ticket.ticketPriorityId, 'id', 'description')}
                                </Typography>
                            </TableCell>
                            {currentUser?.typology === UserType.VitecUser &&
                                <>
                                    <TableCell>
                                        {ticket.reporterName}
                                        {ticket.reporterCompany && <Typography variant="subtitle2">{ticket.reporterCompany}</Typography>}
                                    </TableCell>
                                    <TableCell>
                                        {ticket.assignee ? ticket.assignee : "unassigned"}
                                        <br />
                                        {userGroups
                                            .filter(x => ticket.groups.indexOf(x.key) !== -1)
                                            .map(x => x.value.replace('Department', ''))
                                            .join(', ')
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {customerServiceUsers.getValueByKey(ticket.customerServiceAssignee) ?? "unassigned"}
                                    </TableCell>
                                </>
                            }
                            <TableCell>{ticket.title}</TableCell>
                            {currentUser?.canDeleteTickets &&
                                <TableCell align="right">
                                    <DeleteIconButton onClick={() => deleteTicket(ticket.ticketNumber)} stopPropagation />
                                </TableCell>
                            }
                        </ClickableTableRow>
                    )}
                </TableBody>
                {recordCount === 0 &&
                    <TableFooter>
                        <TableRow>
                            {currentUser?.typology === UserType.VitecUser &&
                                <TableCell colSpan={currentUser.canDeleteTickets ? currentUser.canDoBulkEdit ? 9 : 8 : 7}>
                                    <i>No tickets were found</i>
                                </TableCell>
                            }
                            {currentUser?.typology === UserType.Customer &&
                                <TableCell colSpan={4}><i>No tickets were found</i></TableCell>
                            }
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </TableContainer>
    )
}

export default Results;